import React, { useEffect } from "react";
import $ from "jquery";
import "magnific-popup";
import Loader from "../components/Loader";
import parse from "html-react-parser";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import Newsletter from "../components/Newsletter";
import Breadcrumbs from "../components/Breadcrumbs";
import { Link, useLocation } from "react-router-dom";
import StructuredData from "../seo/StructuredData";
import { breadcrumbJsonLd } from "../seo/jsonld";
import { DEFAULT_OG_IMAGE, SITE_NAME, SITE_URL } from "../seo/site";
/*import GalleryMini from "../components/GalleryMini";*/

export default function Locations({ setHeader }) {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const pageLang = i18n?.language === "me" ? "me" : "en";
  const pageUrl = `${SITE_URL}${location.pathname}`;
  const pageTitle = `${t("header.locations.pageTitle")} - ${SITE_NAME}`;
  const pageDescription = t("header.locations.metaDescription");
  const enUrl = `${SITE_URL}/en/perfumeries`;
  const meUrl = `${SITE_URL}/me/parfimerije`;
  const breadcrumbItems = [
    { name: SITE_NAME, item: `${SITE_URL}/${pageLang}` },
    { name: t("header.locations.pageTitle"), item: pageUrl },
  ];

  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > 1) {
        setHeader(true);
      } else {
        setHeader(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [setHeader]);

  useEffect(() => {
    $(".image-popup").magnificPopup({
      type: "image",
      callbacks: {
        beforeOpen: function () {
          this.st.image.markup = this.st.image.markup.replace(
            "mfp-figure",
            "mfp-figure animated zoomInDown"
          );
        },
      },
      gallery: {
        enabled: true,
      },
    });
  }, []);

  return (
    <>
      <Helmet htmlAttributes={{ lang: pageLang }}>
        {/* <!-- meta tag --> */}
        <meta charset="utf-8" />
        <title>
          {pageTitle}
        </title>

        {/* <!-- Meta Tags--> */}
        <meta
          name="description"
          content={pageDescription}
        />
        <meta
          name="keywords"
          content="durō, duro, niche perfumery, niche parfimerija,  parfimerija, galerija"
        />
        <meta name="author" content="intellect.se" />
        <link rel="canonical" href={pageUrl} />
        <link rel="alternate" href={enUrl} hreflang="en" />
        <link rel="alternate" href={meUrl} hreflang="me" />
        <link rel="alternate" href={enUrl} hreflang="x-default" />

        {/* <!-- responsive tag --> */}
        <meta http-equiv="x-ua-compatible" content="ie=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* <!-- Facebook Metadata --> */}
        <meta property="og:type" content="website" />
        <meta property="og:image:height" content="1200" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={DEFAULT_OG_IMAGE} />
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:title" content={pageTitle} />
        <meta property="twitter:description" content={pageDescription} />
        <meta property="twitter:url" content={pageUrl} />
        <meta property="twitter:image" content={DEFAULT_OG_IMAGE} />
      </Helmet>
      <Loader />
      {/* <!-- Main content Start --> */}
      <div className="main-content">
        {/* <!-- Breadcrumbs Start --> */}
        <div className="rs-breadcrumbs img9">
          <div className="container">
            <div className="breadcrumbs-inner">
              <h1 className="page-title">
                {t("header.locations.menuTitle")}
                {/*<span className="watermark">{gallery}</span>*/}
              </h1>
            </div>
          </div>
        </div>
        <Breadcrumbs />
        {/* <!-- Breadcrumbs End --> */}

        {/* <!-- Podgorica Section Start --> */}
        <div className="rs-about style1 lion-bg pt-120 pb-120 md-pt-80 md-pb-75">
          <div className="container">
            <div className="row y-middle">
              <div className="col-lg-6 pl-50 md-pl-15">
                <div className="rs-videos choose-video">
                  <div className="images-video">
                    <img
                      src="/assets/images/about/about-12.png"
                      alt="DURŌ Podgorica"
                    />
                  </div>
                  <div className="animate-border">
                    <a
                      className="popup-border"
                      href="https://www.youtube.com/watch?v=I9IFUUBni_E"
                    >
                      <i className="fa fa-play"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 pl-45 md-pl-15">
                <div className="sec-title">
                  <span className="sub-text">
                    DURŌ {parse(t("locations.podgorica.perfumery"))}
                  </span>
                  <h2 className="title pb-22">
                    {t("locations.podgorica.tagline")}
                  </h2>
                  <div className="heading-border-line left-style"></div>
                </div>
                <p className="desc margin-0 pt-40 pb-15">
                  {parse(t("locations.podgorica.shortStory"))}
                </p>
                <div className="btn-part mt-15">
                  <Link
                    className="readon btn-text ticket"
                    to={`/${i18n.language}/${
                      i18n.language === "en" ? "perfumeries" : "parfimerije"
                    }/podgorica`}
                  >
                    <span>{t("locations.links.learn-more")}</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- Podgorica Section End --> */}

        {/* <!-- Capital Plaza Section Start --> */}
        <div className="rs-services style4 lion-bg pt-80 pb-80 md-pt-80 md-pb-80">
          <div className="container">
            <div className="row y-middle">
              <div className="col-lg-6 pl-45 md-pl-15">
                <div className="sec-title">
                  <span className="sub-text">
                    DURŌ {parse(t("locations.capital-plaza-podgorica.perfumery"))}
                  </span>
                  <h2 className="title pb-22">
                    {t("locations.capital-plaza-podgorica.tagline")}
                  </h2>
                  <div className="heading-border-line left-style"></div>
                </div>
                <p className="desc margin-0 pt-40 pb-15">
                  {parse(t("locations.capital-plaza-podgorica.shortStory"))}
                </p>
                <div className="btn-part mt-15">
                  <Link
                    className="readon btn-text ticket"
                    to={`/${i18n.language}/${
                      i18n.language === "en" ? "perfumeries" : "parfimerije"
                    }/capital-plaza-podgorica`}
                  >
                    <span>{t("locations.links.learn-more")}</span>
                  </Link>
                </div>
              </div>
              <div className="col-lg-6 pl-50 md-pl-15">
                <div className="rs-videos choose-video">
                  <div className="images-video">
                    <img
                      src="/assets/images/about/about-14.png"
                      alt="DURŌ Capital Plaza"
                    />
                  </div>
                  {/*<div className="animate-border">
                    <a
                      className="popup-border"
                      href="https://www.youtube.com/watch?v=I9IFUUBni_E"
                    >
                      <i className="fa fa-play"></i>
                    </a>
                  </div>*/}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- Capital Plaza Section End --> */}

        {/* <!-- Porto Montenegro Section Start --> */}
        <div className="rs-services style4 lion-bg pt-80 pb-80 md-pt-80 md-pb-80">
          <div className="container">
            <div className="row y-middle">
              <div className="col-lg-6 pl-50 md-pl-15">
                <div className="rs-videos choose-video">
                  <div className="images-video">
                    <img src="/assets/images/about/about-13.png" alt="DURŌ" />
                  </div>
                  <div className="animate-border">
                    <a
                      className="popup-border"
                      href="https://www.youtube.com/watch?v=rZhg7Y2CCpY"
                    >
                      <i className="fa fa-play"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 pl-45 md-pl-15">
                <div className="sec-title">
                  <span className="sub-text">
                    DURŌ {parse(t("locations.porto-montenegro.perfumery"))}
                  </span>
                  <h2 className="title pb-22">
                    {t("locations.porto-montenegro.tagline")}
                  </h2>
                  <div className="heading-border-line left-style"></div>
                </div>
                <p className="desc margin-0 pt-40 pb-15">
                  {parse(t("locations.porto-montenegro.shortStory"))}
                </p>
                <div className="btn-part mt-15">
                  <Link
                    className="readon btn-text ticket"
                    to={`/${i18n.language}/${
                      i18n.language === "en" ? "perfumeries" : "parfimerije"
                    }/porto-montenegro`}
                  >
                    <span>{t("locations.links.learn-more")}</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- Porto Montenegro Section End --> */}

        {/* <!-- Newsletter section start --> */}
        <div className="rs-newsletter lion-bg style1 pt-90 md-pt-60 mb--110">
          <Newsletter />
        </div>
        {/* <!-- Newsletter section end --> */}
      </div>
      {/* <!-- Main content End --> */}
      <StructuredData data={breadcrumbJsonLd(breadcrumbItems)} />
    </>
  );
}
